import ExamUploadForm from "../../../../components/Forms/ExamUploadForm";
import { VACCPASS } from "../../../../constants";



export const VaccsUpload = () => {

   
return (
<>

<ExamUploadForm

    exam_url = { VACCPASS }

/>
 
</>
)};
